// ===== 修复 GitLab issue #2：鼠标点过 el-tabs 页签后按 Shift 键，页签外多出主题色边框 =====
// 根因：.el-tabs__item 是可聚焦元素（tabindex=0）。鼠标点击页签后它持有 DOM 焦点
//（鼠标操作本身不显示焦点框），随后按下 Shift 等键盘按键被浏览器判定为键盘交互，
// :focus-visible 立即匹配当前焦点元素，EP 默认的焦点 outline（跟随 --el-color-primary）
// 便渲染成一圈紫色圆角边框。
// 方案：鼠标在页签上按下时 preventDefault，阻止「鼠标点击使页签获得焦点」这一默认行为，
// 页签从此不再持有焦点，后续任何按键都不会触发 :focus-visible 的焦框。
// preventDefault 只取消默认聚焦，click 事件照常触发，页签切换不受影响；
// 键盘 Tab 导航聚焦页签时焦点环正常显示（符合设计规范 11-responsive-accessibility：
// 不得移除 EP 组件自身 focus 样式，这里并未移除，只是让鼠标点击不再产生焦点）。
document.addEventListener(
  'mousedown',
  (e) => {
    if (e.target.closest && e.target.closest('.el-tabs__item')) {
      e.preventDefault()
    }
  },
  true
)
